
import { Button, Dialog, FormGroup, FormControlLabel, Checkbox, Tooltip } from "@mui/material"
import styles from "./selectAggregatioModal.module.scss"
import { useTranslation } from "react-i18next";
import { useContext, useState, useEffect } from "react";
import { AppAction, AppContext } from "helpers/context";

interface Props {
    open: boolean;
    handleClose: () => void;
    handleGenerate: (aggregationUnits: string[]) => void;
}

function SelectAggregatioModal(props: Props) {
    const [context, dispatch] = useContext(AppContext);
    const [t] = useTranslation();
    let options = [{
        value: "numberOfLocations",
        checked: true
    }, {
        value: "total",
        checked: true
    }, {
        value: "numberOfRisks",
        checked: true
    }, {
        value: "building",
        checked: true
    }, {
        value: "content",
        checked: true
    }, {
        value: "businessInterruption",
        checked: true
    }, {
        value: "propertyDamage",
        checked: true
    }, {
        value: "limit",
        checked: true
    }, {
        value: "deductible",
        checked: true
    }, {
        value: "other",
        checked: true
    }]
    const [aggregationUnitOptions, setAggregationUnitOptions] = useState<any[]>([]);

    const close = () => {
        props.handleClose()
    }

    const handleClick = () => {
        props.handleGenerate(aggregationUnitOptions.filter(item => item.checked).map(item => item.value))
    }

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
        let arr = [...aggregationUnitOptions]
        arr[index].checked = event.target.checked;
        setAggregationUnitOptions([...arr])
    }

    useEffect(() => {
        setAggregationUnitOptions(options.filter((item) => item.value === "numberOfLocations" || context.currentMultipleLocations?.items?.find((location: any) => location[item.value])))
    }, [context.currentMultipleLocations?.items])

    return (<Dialog
        open={props.open}
        onClose={close}
        sx={{
            "& .MuiDialog-paper": {
                width: "430px",
                maxWidth: "80vw",
                maxHeight: "85vh",
                borderRadius: "4px"
            }
        }}
    >
        <div className={styles.container}>
            <div className={styles.header}>{t("multiple.Generate location set analysis report")}</div>
            <div className={styles.context}>
                <p>{t("multiple.Please select the aggregation units to include into the report")}</p>
                <div className={styles.group}>
                    <FormGroup>
                        {aggregationUnitOptions.map((item, index) => {
                            let isDisabled = context.currentMultipleLocations?.aggregationUnit === item.value
                            return <Tooltip
                                key={item.value}
                                disableHoverListener={!isDisabled}
                                title={t("multiple.Current visualized value cannot be unselected because it is required to show the locations map in the report")}
                            >
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={item.checked}
                                            onChange={(event) => handleChange(event, index)}
                                            color="success"
                                            size="small"
                                        />
                                    }
                                    label={t("locations." + item.value)}
                                    disabled={isDisabled}
                                    sx={{
                                        "& .MuiTypography-root": {
                                            fontSize: "13px"
                                        }
                                    }}
                                />
                            </Tooltip>
                        })}
                    </FormGroup>
                </div>
                <div className={styles.button}>
                    <Button onClick={close} color="success">{t("buttons.cancel")}</Button>
                    <Button onClick={handleClick} color="success" variant="contained">{t("buttons.Generate")}</Button>
                </div>
            </div>
        </div>
    </Dialog >);
}

export default SelectAggregatioModal;


